import React from 'react';
import Seo from '../seo/Seo';
import { breadcrumbLd, LINKEDIN_COMPANY, LINKEDIN_PRINCIPAL } from '../seo/jsonLd';
import Breadcrumb from './Breadcrumb';
import ContactForm from './ContactForm';
import BookAssessment from './BookAssessment';
import { CONTACT_EMAIL } from '../site';

const CRUMBS = [{ name: 'Home', path: '/' }, { name: 'Contact' }];

// Accent belongs to the booking. These are the footer's treatment: grey until you
// reach for them, so the one primary action in the column keeps its weight.
const LINK_CLASS =
  'inline-flex min-h-[24px] items-center py-1 text-gray-300 transition-colors duration-150 hover:text-accent-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 [@media(pointer:coarse)]:min-h-[44px] [@media(pointer:coarse)]:py-2.5';

const ContactPage: React.FC = () => (
  <div className="bg-gray-900 text-white">
    <Seo
      title="Contact | Kult.io"
      description="Write to us, or book a free thirty-minute assessment. Kraków, working internationally."
      path="/contact"
      jsonLd={breadcrumbLd(CRUMBS)}
    />

    <div className="border-b border-gray-800 bg-gray-950">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 md:py-20">
        <h1 className="font-display text-display-md font-bold text-balance text-white sm:text-display-lg">
          Tell us what you need
        </h1>
        <p className="mt-6 max-w-measure text-lg text-gray-300">
          We read every message and reply ourselves. If a call is faster, book the free assessment
          instead.
        </p>
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 md:py-20">
      <Breadcrumb crumbs={CRUMBS} />

      <div className="mt-10 grid gap-x-16 gap-y-14 border-t border-gray-800 pt-10 lg:grid-cols-2">
        <div className="max-w-lg">
          <h2 className="font-display text-display-sm font-medium text-white">Send a message</h2>
          <div className="mt-6">
            <ContactForm idPrefix="contact" />
          </div>
        </div>

        <div>
          <h2 className="font-display text-display-sm font-medium text-white">Prefer a call?</h2>
          <p className="mt-4 max-w-measure text-gray-300">
            Bring one process your team does by hand every week. Thirty minutes, no charge.
          </p>
          <BookAssessment placement="contact-page" variant="inline" className="mt-1" />

          <h2 className="mt-12 font-display text-display-sm font-medium text-white">Where we are</h2>
          <address className="mt-4 space-y-3 not-italic text-gray-400">
            <p>Aleja Powstania Warszawskiego 15</p>
            <p>31-539 Kraków</p>
            <p>Poland</p>
            <p>
              <a href={`mailto:${CONTACT_EMAIL}`} className={LINK_CLASS}>
                {CONTACT_EMAIL}
              </a>
            </p>
          </address>

          <ul className="mt-6 space-y-3 text-gray-400">
            <li>
              <a href={LINKEDIN_COMPANY} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
                Kult.io on LinkedIn
              </a>
            </li>
            <li>
              <a href={LINKEDIN_PRINCIPAL} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
                Rafał Janicki on LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default ContactPage;
